export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/837e258702481769ad64684ae735d0c9.svg";